var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHr = function SvgHr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27.5,
    height: 19.5,
    x: 0.25,
    y: 0.25,
    fill: "#fff",
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    rx: 1.75
  })), /*#__PURE__*/React.createElement("mask", {
    id: "HR_svg__a",
    width: 28,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 27.5,
    height: 19.5,
    x: 0.25,
    y: 0.25,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    rx: 1.75
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#HR_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF202D",
    d: "M0 6.667h28V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1895DB",
    d: "m10.667 5.333.666-.667.667.667v1.334h-1.333zm2.666 0L14 4.666l.667.667v1.334h-1.334zm3.334-.667L16 5.334v1.334h1.333V5.333z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191F94",
    d: "M12.667 4.667 12 5.333v1.334h1.333V5.333zm2.666 0-.666.666v1.334H16V5.333z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2027AC",
    d: "M0 20h28v-6.666H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#HR_svg__b)",
    d: "M12 6.667h-.667L10.667 8H12v1.333h-1.333v1.333H12V12h-1.333v1.333H12v1.333h1.333v-1.333h1.334v1.333H16v-1.333h1.333V12H16v-1.334h1.333V9.333H16V8h1.333l-.666-1.333H16V8h-1.333V6.667h-1.334V8H12zm1.333 2.666V8h1.334v1.333zm0 1.333V9.333H12v1.333zm1.334 0h-1.334V12H12v1.333h1.333V12h1.334v1.333H16V12h-1.333zm0 0H16V9.333h-1.333z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "HR_svg__b",
    x1: 10.667,
    x2: 10.667,
    y1: 6.667,
    y2: 14.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF212E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD0D1B"
  })))));
};
export { SvgHr as ReactComponent };
export default "data:image/svg+xml;base64,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";